import type { TExcursionFiltersState } from '@/entities/filter/store/excursion';

export const excursionCheckAppliedFilters = (searchState: TExcursionFiltersState): boolean => {
  const hasDate = searchState.date.from || searchState.date.to || searchState.date.persons > 1;
  const hasTypes = searchState.type?.length;
  const hasFormats = searchState.tourFormat?.length;
  const hasMovement = searchState.movementTypes?.length;
  const hasPrice = searchState.price.some((p) => p !== null);
  const hasDuration = searchState.duration.some((d) => d !== null);
  const hasStartTime = searchState.startTimeInterval?.length;
  const hasChildren = searchState.childrenAllowed;
  const hasDurationInterval = searchState.durationInterval?.length;

  return Boolean(
    hasDate ||
    hasTypes ||
    hasMovement ||
    hasPrice ||
    hasDuration ||
    hasStartTime ||
    hasChildren ||
    hasDurationInterval ||
    hasFormats,
  );
};

export const excursionCheckOnlyDateAppliedFilters = (searchState: TExcursionFiltersState): boolean => {
  const hasDate = searchState.date.from || searchState.date.to || searchState.date.persons > 1;
  const hasTypes = searchState.type?.length;
  const hasFormats = searchState.tourFormat?.length;
  const hasMovement = searchState.movementTypes?.length;
  const hasPrice = searchState.price.some((p) => p !== null);
  const hasDuration = searchState.duration.some((d) => d !== null);
  const hasStartTime = searchState.startTimeInterval?.length;
  const hasChildren = searchState.childrenAllowed;
  const hasDurationInterval = searchState.durationInterval?.length;

  return Boolean(
    hasDate &&
    !(
      hasTypes ||
      hasMovement ||
      hasPrice ||
      hasDuration ||
      hasStartTime ||
      hasChildren ||
      hasDurationInterval ||
      hasFormats
    ),
  );
};
